import { ChildrenProps, DialogForm } from '@dfl/mui-react-common';
import { Close, DoneAll } from '@mui/icons-material';
import { Alert, Button, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import WarningIcon from 'modules/inventory/product-stock/components/Icons/WarningIcon';
import { ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = ChildrenProps & {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  title: ReactNode;
  className?: string;
  subtitle?: ReactNode;
  confirmText?: string;
};

const WarningDialog = ({ children, onClose, open, title, className, onConfirm, confirmText, subtitle, ...rest }: Props) => {
  const { t } = useTranslation('common');

  return (
    <DialogForm open={open} {...rest} title={title} subtitle={subtitle} maxWidth='sm'>
      <IconButton sx={{ position: 'absolute', top: 10, right: 10 }} onClick={onClose}>
        <Close />
      </IconButton>
      <DialogContent>
        {children}
        <Alert severity='warning' icon={<WarningIcon fontSize='small' width={24} height={24} />} sx={{ bgcolor: '#EDEEF0' }}>
          <Typography color={'#2B3445'}>
            {t('order:completeWarning')}
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='grey' sx={{ px: 3 }}>
          {t('cancel')}
        </Button>
        <Button onClick={onConfirm} variant='contained' startIcon={<DoneAll />}>
          {t(confirmText || 'confirm')}
        </Button>
      </DialogActions>
    </DialogForm >
  );
};

export default memo(WarningDialog);
